(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero-scroll-cue"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.sterk-hero-scroll');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const hero = link.closest('.sterk-scroll-hero');
    const section = hero.closest('.shopify-section');
    let target = hero.matches('.location-hero') ? hero.nextElementSibling : section?.nextElementSibling;
    while (target && (target.matches('script, style, link') || target.hidden || target.getBoundingClientRect().height < 2)) {
      target = target.nextElementSibling;
    }
    if (!target) return;

    event.preventDefault();
    const header = document.querySelector('header[is="sticky-header"][data-sticky-type="always"]');
    const top = target.getBoundingClientRect().top + window.scrollY - (header?.getBoundingClientRect().height || 0);
    const focusTarget = target.querySelector('h1, h2, h3') || target;
    if (!focusTarget.hasAttribute('tabindex')) {
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
    }
    focusTarget.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
